/*
    Link Button
*/

// Show Hover State
var showHoverLinkButton = document.getElementById('show-hover-link-button');
showHoverLinkButton.addEventListener('click', function() {
    var hoverLinkButton = document.getElementById('hover-link-button');
    hoverLinkButton.classList.add("show");
    var buttonLinkButton = document.getElementById('button-hover-link-button');
    buttonLinkButton.classList.add("hide");

    // Copy Settings to Hover
    copyLinkButtonSettingsToHover();
});

function copyLinkButtonSettingsToHover() {
    window.customStyle[".MessengerButton:hover"]['background'] = window.customStyle[".MessengerButton"]['background'];
    window.customStyle[".MessengerButton:hover"]['color'] = window.customStyle[".MessengerButton"]['color'];
    window.customStyle[".MessengerButton:hover"]['border-top-left-radius'] = window.customStyle[".MessengerButton"]['border-top-left-radius'];
    window.customStyle[".MessengerButton:hover"]['border-top-right-radius'] = window.customStyle[".MessengerButton"]['border-top-right-radius'];
    window.customStyle[".MessengerButton:hover"]['border-bottom-right-radius'] = window.customStyle[".MessengerButton"]['border-bottom-right-radius'];
    window.customStyle[".MessengerButton:hover"]['border-bottom-left-radius'] = window.customStyle[".MessengerButton"]['border-bottom-left-radius'];
    window.customStyle[".MessengerButton:hover"]['padding-top'] = window.customStyle[".MessengerButton"]['padding-top'];
    window.customStyle[".MessengerButton:hover"]['padding-bottom'] = window.customStyle[".MessengerButton"]['padding-bottom'];
    window.customStyle[".MessengerButton:hover"]['padding-left'] = window.customStyle[".MessengerButton"]['padding-left'];
    window.customStyle[".MessengerButton:hover"]['padding-right'] = window.customStyle[".MessengerButton"]['padding-right'];
    window.customStyle[".MessengerButton:hover"]['margin-top'] = window.customStyle[".MessengerButton"]['margin-top'];
    window.customStyle[".MessengerButton:hover"]['margin-bottom'] = window.customStyle[".MessengerButton"]['margin-bottom'];
    window.customStyle[".MessengerButton:hover"]['margin-left'] = window.customStyle[".MessengerButton"]['margin-left'];
    window.customStyle[".MessengerButton:hover"]['margin-right'] = window.customStyle[".MessengerButton"]['margin-right'];
    window.customStyle[".MessengerButton:hover"]['box-sizing'] = window.customStyle[".MessengerButton"]['box-sizing'];
    window.customStyle[".MessengerButton:hover"]['border'] = window.customStyle[".MessengerButton"]['border'];
    window.customStyle[".MessengerButton:hover"]['box-shadow'] = window.customStyle[".MessengerButton"]['box-shadow'];
    window.customStyle[".MessengerButton:hover"]['font-family'] = window.customStyle[".MessengerButton"]['font-family'];
    window.customStyle[".MessengerButton:hover"]['font-size'] = window.customStyle[".MessengerButton"]['font-size'];
    window.styleElement.textContent = window.css.of(window.customStyle);

    // Copy Background color
    document.getElementById("link-button-color-selector-hover").value = document.getElementById("link-button-color-selector").value;
    document.getElementById("color-preview-link-button-hover").style.backgroundColor = document.getElementById("color-preview-link-button").style.backgroundColor;
    // Copy Text color
    document.getElementById("link-button-text-color-selector-hover").value = document.getElementById("link-button-text-color-selector").value;
    document.getElementById("color-preview-text-link-button-hover").style.backgroundColor = document.getElementById("color-preview-text-link-button").style.backgroundColor;
    // Copy Font style
    document.getElementById("link-button-hover-text-font-selector").value = document.getElementById("link-button-text-font-selector").value;
    document.getElementById("link-button-hover-text-font-selector").style.color = document.getElementById("link-button-text-font-selector").style.color;
    document.getElementById("link-button-hover-text-font-selector").style.fontFamily = document.getElementById("link-button-text-font-selector").style.fontFamily;
    document.getElementById("link-button-hover-text-font-selector").style.fontSize = document.getElementById("link-button-text-font-selector").style.fontSize;
    // Copy Corner Radius
    document.getElementById("corner-radius-topL-link-button-hover").value = document.getElementById("corner-radius-topL-link-button").value;
    document.getElementById("corner-radius-topR-link-button-hover").value = document.getElementById("corner-radius-topR-link-button").value;
    document.getElementById("corner-radius-bottomL-link-button-hover").value = document.getElementById("corner-radius-bottomL-link-button").value;
    document.getElementById("corner-radius-bottomR-link-button-hover").value = document.getElementById("corner-radius-bottomR-link-button").value;
    // Copy Padding
    document.getElementById("padding-top-link-button-hover").value = document.getElementById("padding-top-link-button").value;
    document.getElementById("padding-bottom-link-button-hover").value = document.getElementById("padding-bottom-link-button").value;
    document.getElementById("padding-left-link-button-hover").value = document.getElementById("padding-left-link-button").value;
    document.getElementById("padding-right-link-button-hover").value = document.getElementById("padding-right-link-button").value;
    // Copy Margin
    document.getElementById("margin-top-link-button-hover").value = document.getElementById("margin-top-link-button").value;
    document.getElementById("margin-bottom-link-button-hover").value = document.getElementById("margin-bottom-link-button").value;
    document.getElementById("margin-left-link-button-hover").value = document.getElementById("margin-left-link-button").value;
    document.getElementById("margin-right-link-button-hover").value = document.getElementById("margin-right-link-button").value;
    // Copy Border
    borderColorHover = borderColor;
    borderWidthHover = borderWidth
    borderStringHover = borderString;
    document.getElementById("link-button-border-selector-hover").value = document.getElementById("link-button-border-selector").value;
    document.getElementById("link-button-hover-border-color-selector").value = document.getElementById("link-button-border-color-selector").value;
    document.getElementById("color-border-preview-link-button-hover").style.backgroundColor = document.getElementById("color-border-preview-link-button").style.backgroundColor;
    document.getElementById("width-border-link-button-hover").value = document.getElementById("width-border-link-button").value;
    // Copy Shadow
    hOffsetHover = hOffset;
    vOffsetHover = vOffset;
    blurShadowHover = blurShadow;
    spreedHover = spreed;
    shadowColorHover = shadowColor;
    shadowPosHover = shadowPos;
    document.getElementById("link-button-shadow-h-offset-hover").value = document.getElementById("link-button-shadow-h-offset").value;
    document.getElementById("link-button-shadow-v-offset-hover").value = document.getElementById("link-button-shadow-v-offset").value;
    document.getElementById("link-button-shadow-blur-hover").value = document.getElementById("link-button-shadow-blur").value;
    document.getElementById("link-button-shadow-spreed-hover").value = document.getElementById("link-button-shadow-spreed").value;
    document.getElementById("link-button-shadow-color-selector-hover").value = document.getElementById("link-button-shadow-color-selector").value;
    document.getElementById("color-shadow-preview-color-link-button-hover").style.backgroundColor = document.getElementById("color-shadow-preview-color-link-button").style.backgroundColor;
    document.getElementById("link-button-shadow-position-hover").value = document.getElementById("link-button-shadow-position").value;
}


// Link Button Background Color
var select = document.getElementById('link-button-color-selector');
var colorPreview = document.getElementById('color-preview-link-button');
window.updateLinkButtonColor = function() {
    select.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    select.appendChild(option);

    colorPreview.style.backgroundColor = "transparent";
    colorPreview.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        select.appendChild(option);
    }
}
select.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreview.style.backgroundColor = val.settings.color;
            window.customStyle[".MessengerButton"]["background"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreview.style.backgroundColor = "transparent";
        colorPreview.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerButton']['background'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreview.style.border = "transparent !important";
    }
});

// Link Button Text Color
var selectText = document.getElementById('link-button-text-color-selector');
var colorPreviewText = document.getElementById('color-preview-text-link-button');
window.updateLinkButtonTextColor = function() {
    selectText.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectText.appendChild(option);

    colorPreviewText.style.backgroundColor = "transparent";
    colorPreviewText.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectText.appendChild(option);
    }
}
selectText.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewText.style.backgroundColor = val.settings.color;
            window.customStyle[".MessengerButton"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewText.style.backgroundColor = "transparent";
        colorPreviewText.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerButton']['color'] = "black !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewText.style.border = "transparent !important";
    }
})

// Link Button Font Style
var selectFont = document.getElementById("link-button-text-font-selector");
window.updateLinkButtonFonts = function() {
    selectFont.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Fonts";
    selectFont.appendChild(option);

    for (const val of window.fonts.fonts) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        option.setAttribute("data-id", val.id);
        selectFont.appendChild(option);
    }
}
selectFont.addEventListener("change", function(event) {
    for (const val of window.fonts.fonts) {
        if (val.settings.name == event.target.value) {
            selectFont.style.color = val.settings.color;
            selectFont.style.fontFamily = val.settings.fontFamily;
            selectFont.style.fontSize = val.settings.size;

            window.customStyle[".MessengerButton"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".MessengerButton"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".MessengerButton"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
})

// Corner Radius
var cornerRadiusTopL = document.getElementById('corner-radius-topL-link-button');
cornerRadiusTopL.addEventListener('change', function(event) {
    window.customStyle[".MessengerButton"]["border-top-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusTopR = document.getElementById('corner-radius-topR-link-button');
cornerRadiusTopR.addEventListener('change', function(event) {
    window.customStyle[".MessengerButton"]["border-top-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomR = document.getElementById('corner-radius-bottomR-link-button');
cornerRadiusBottomR.addEventListener('change', function(event) {
    window.customStyle[".MessengerButton"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomL = document.getElementById('corner-radius-bottomL-link-button');
cornerRadiusBottomL.addEventListener('change', function(event) {
    window.customStyle[".MessengerButton"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Padding
var paddingTop = document.getElementById('padding-top-link-button');
paddingTop.addEventListener('change', function(event){
    window.customStyle[".MessengerButton"]["padding-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingBottom = document.getElementById('padding-bottom-link-button');
paddingBottom.addEventListener('change', function(event){
    window.customStyle[".MessengerButton"]["padding-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingLeft = document.getElementById('padding-left-link-button');
paddingLeft.addEventListener('change', function(event){
    window.customStyle[".MessengerButton"]["padding-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingRight = document.getElementById('padding-right-link-button');
paddingRight.addEventListener('change', function(event){
    window.customStyle[".MessengerButton"]["padding-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Margin
var marginTop = document.getElementById('margin-top-link-button');
marginTop.addEventListener('change', function(event){
    window.customStyle[".MessengerButton"]["margin-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginBottom = document.getElementById('margin-bottom-link-button');
marginBottom.addEventListener('change', function(event){
    window.customStyle[".MessengerButton"]["margin-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginLeft = document.getElementById('margin-left-link-button');
marginLeft.addEventListener('change', function(event){
    window.customStyle[".MessengerButton"]["margin-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginRight = document.getElementById('margin-right-link-button');
marginRight.addEventListener('change', function(event){
    window.customStyle[".MessengerButton"]["margin-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Border
var borderColor = "black";
var borderWidth = "1px";
var borderString = borderWidth + " solid " + borderColor;

var selectBorderPos = document.getElementById('link-button-border-selector');
selectBorderPos.addEventListener('change', function(event) {
    if (event.target.value == "inside") {
        window.customStyle[".MessengerButton"]["box-sizing"] = "border-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        window.customStyle[".MessengerButton"]["box-sizing"] = "content-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
})

var selectBorder = document.getElementById('link-button-border-color-selector');
var colorPreviewBorder = document.getElementById('color-border-preview-link-button');
window.updateLinkButtonBorderColor = function() {
    selectBorder.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectBorder.appendChild(option);

    colorPreviewBorder.style.backgroundColor = "transparent";
    colorPreviewBorder.style.border = "#5D5D5D 1px solid";

    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectBorder.appendChild(option);
    }
}
selectBorder.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewBorder.style.backgroundColor = val.settings.color;

            borderColor = val.settings.color;
            borderString = borderWidth + " solid " + borderColor;
            window.customStyle[".MessengerButton"]["border"] = borderString + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewBorder.style.backgroundColor = "transparent";
        colorPreviewBorder.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerButton']['border'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewBorder.style.border = "transparent";
    }
});

var widthBorder = document.getElementById('width-border-link-button');
widthBorder.addEventListener('change', function(event) {
    borderWidth = event.target.value;
    borderString = borderWidth + " solid " + borderColor;
    window.customStyle[".MessengerButton"]["border"] = borderString + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Shadow
var hOffset = "0px";
var vOffset = "0px";
var blurShadow = "0px";
var spreed = "0px";
var shadowColor = "#000";
var shadowPos = "";

var hOffsetElement = document.getElementById("link-button-shadow-h-offset");
hOffsetElement.addEventListener("change", function(event) {

    hOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerButton"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var vOffsetElement = document.getElementById("link-button-shadow-v-offset");
vOffsetElement.addEventListener("change", function(event) {

    vOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerButton"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var blurElement = document.getElementById("link-button-shadow-blur");
blurElement.addEventListener("change", function(event) {

    blurShadow = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerButton"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var spreedElement = document.getElementById("link-button-shadow-spreed");
spreedElement.addEventListener("change", function(event) {

    spreed = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerButton"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var selectShadow = document.getElementById('link-button-shadow-color-selector');
var colorPreviewShadow = document.getElementById('color-shadow-preview-color-link-button');
window.updateLinkButtonShadowColor = function() {
    selectShadow.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectShadow.appendChild(option);

    colorPreviewShadow.style.backgroundColor = "transparent";
    colorPreviewShadow.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectShadow.appendChild(option);
    }
}
selectShadow.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewShadow.style.backgroundColor = val.settings.color;

            shadowColor = val.settings.color;
            var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";
            window.customStyle[".MessengerButton"]["box-shadow"] = shadow;
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewShadow.style.backgroundColor = "transparent";
        colorPreviewShadow.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerButton']['box-shadow'] = "none !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewShadow.style.border = "transparent";
    }
});

var shadowPosElement = document.getElementById("link-button-shadow-position");
shadowPosElement.addEventListener("change", function(event) {
    if (event.target.value == "inner") {
        shadowPos = "inset";
    } else {
        shadowPos = "";
    }
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerButton"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})


/*
    LINK BUTTON HOVER
*/

// Link Button Hover Background Color
var selectHover = document.getElementById('link-button-color-selector-hover');
var colorPreviewHover = document.getElementById('color-preview-link-button-hover');
window.updateLinkButtonHoverColor = function() {
    selectHover.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectHover.appendChild(option);

    colorPreviewHover.style.backgroundColor = "transparent";
    colorPreviewHover.style.border = "#5D5D5D 1px solid";
        
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectHover.appendChild(option);
    }
}
selectHover.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewHover.style.backgroundColor = val.settings.color;
            window.customStyle[".MessengerButton:hover"]["background"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    
    if (event.target.value == "") {
        colorPreviewHover.style.backgroundColor = "transparent";
        colorPreviewHover.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerButton:hover']['background'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewHover.style.border = "transparent";
    }
});

// Link Button Hover Text Color
var selectTextHover = document.getElementById('link-button-text-color-selector-hover');
var colorPreviewTextHover = document.getElementById('color-preview-text-link-button-hover');
window.updateLinkButtonHoverTextColor = function() {
    selectTextHover.replaceChildren();
    
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectTextHover.appendChild(option);

    colorPreviewTextHover.style.backgroundColor = "transparent";
    colorPreviewTextHover.style.border = "#5D5D5D 1px solid";
        
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectTextHover.appendChild(option);
    }
}
selectTextHover.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewTextHover.style.backgroundColor = val.settings.color;
            window.customStyle[".MessengerButton:hover"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewTextHover.style.backgroundColor = "transparent";
        colorPreviewTextHover.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerButton:hover']['color'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewTextHover.style.border = "transparent";
    }
})

// Link Button Hover Font Style
var selectFontHover = document.getElementById("link-button-hover-text-font-selector");
window.updateLinkButtonFontsHover = function() {
    selectFontHover.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Fonts";
    selectFontHover.appendChild(option);

    for (const val of window.fonts.fonts) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        option.setAttribute("data-id", val.id);
        selectFontHover.appendChild(option);
    }
}
selectFontHover.addEventListener("change", function(event) {
    for (const val of window.fonts.fonts) {
        if (val.settings.name == event.target.value) {
            selectFontHover.style.color = val.settings.color;
            selectFontHover.style.fontFamily = val.settings.fontFamily;
            selectFontHover.style.fontSize = val.settings.size;

            window.customStyle[".MessengerButton:hover"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".MessengerButton:hover"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".MessengerButton:hover"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
})

// Corner Radius Hover
var cornerRadiusTopLHover = document.getElementById('corner-radius-topL-link-button-hover');
cornerRadiusTopLHover.addEventListener('change', function(event) {
    window.customStyle[".MessengerButton:hover"]["border-top-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusTopRHover = document.getElementById('corner-radius-topR-link-button-hover');
cornerRadiusTopRHover.addEventListener('change', function(event) {
    window.customStyle[".MessengerButton:hover"]["border-top-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomRHover = document.getElementById('corner-radius-bottomR-link-button-hover');
cornerRadiusBottomRHover.addEventListener('change', function(event) {
    window.customStyle[".MessengerButton:hover"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomLHover = document.getElementById('corner-radius-bottomL-link-button-hover');
cornerRadiusBottomLHover.addEventListener('change', function(event) {
    window.customStyle[".MessengerButton:hover"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Padding Hover
var paddingTopHover = document.getElementById('padding-top-link-button-hover');
paddingTopHover.addEventListener('change', function(event){
    window.customStyle[".MessengerButton:hover"]["padding-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingBottomHover = document.getElementById('padding-bottom-link-button-hover');
paddingBottomHover.addEventListener('change', function(event){
    window.customStyle[".MessengerButton:hover"]["padding-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingLeftHover = document.getElementById('padding-left-link-button-hover');
paddingLeftHover.addEventListener('change', function(event){
    window.customStyle[".MessengerButton:hover"]["padding-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingRightHover = document.getElementById('padding-right-link-button-hover');
paddingRightHover.addEventListener('change', function(event){
    window.customStyle[".MessengerButton:hover"]["padding-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Margin Hover
var marginTopHover = document.getElementById('margin-top-link-button-hover');
marginTopHover.addEventListener('change', function(event){
    window.customStyle[".MessengerButton:hover"]["margin-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginBottomHover = document.getElementById('margin-bottom-link-button-hover');
marginBottomHover.addEventListener('change', function(event){
    window.customStyle[".MessengerButton:hover"]["margin-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginLeftHover = document.getElementById('margin-left-link-button-hover');
marginLeftHover.addEventListener('change', function(event){
    window.customStyle[".MessengerButton:hover"]["margin-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginRightHover = document.getElementById('margin-right-link-button-hover');
marginRightHover.addEventListener('change', function(event){
    window.customStyle[".MessengerButton:hover"]["margin-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Border Hover
var borderColorHover = "black";
var borderWidthHover = "1px";
var borderStringHover = borderWidthHover + " solid " + borderColorHover;

var selectBorderPosHover = document.getElementById('link-button-border-selector-hover');
selectBorderPosHover.addEventListener('change', function(event) {
    if (event.target.value == "inside") {
        window.customStyle[".MessengerButton:hover"]["box-sizing"] = "border-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        window.customStyle[".MessengerButton:hover"]["box-sizing"] = "content-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
})

var selectBorderHover = document.getElementById('link-button-hover-border-color-selector');
var colorPreviewBorderHover = document.getElementById('color-border-preview-link-button-hover');
window.updateLinkButtonHoverBorderColor = function() {
    selectBorderHover.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectBorderHover.appendChild(option);

    colorPreviewBorderHover.style.backgroundColor = "transparent";
    colorPreviewBorderHover.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectBorderHover.appendChild(option);
    }
}
selectBorderHover.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewBorderHover.style.backgroundColor = val.settings.color;
            borderColorHover = val.settings.color;
            borderStringHover = borderWidthHover + " solid " + borderColorHover;
            window.customStyle[".MessengerButton:hover"]["border"] = borderStringHover + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewBorderHover.style.backgroundColor = "transparent";
        colorPreviewBorderHover.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerButton:hover']['border'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewBorderHover.style.border = "transparent";
    }
});

var widthBorderHover = document.getElementById('width-border-link-button-hover');
widthBorderHover.addEventListener('change', function(event) {
    borderWidthHover = event.target.value;
    console.log(borderWidthHover);
    borderStringHover = borderWidthHover + " solid " + borderColorHover;
    window.customStyle[".MessengerButton:hover"]["border"] = borderStringHover + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Shadow Hover
var hOffsetHover = "0px";
var vOffsetHover = "0px";
var blurShadowHover = "0px";
var spreedHover = "0px";
var shadowColorHover = "#000";
var shadowPosHover = "";

var hOffsetElementHover = document.getElementById("link-button-shadow-h-offset-hover");
hOffsetElementHover.addEventListener("change", function(event) {

    hOffsetHover = event.target.value;
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerButton:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var vOffsetElementHover = document.getElementById("link-button-shadow-v-offset-hover");
vOffsetElementHover.addEventListener("change", function(event) {

    vOffsetHover = event.target.value;
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerButton:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var blurElementHover = document.getElementById("link-button-shadow-blur-hover");
blurElementHover.addEventListener("change", function(event) {

    blurShadowHover = event.target.value;
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerButton:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var spreedElementHover = document.getElementById("link-button-shadow-spreed-hover");
spreedElementHover.addEventListener("change", function(event) {

    spreedHover = event.target.value;
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerButton:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var selectShadowHover = document.getElementById('link-button-shadow-color-selector-hover');
var colorPreviewShadowHover = document.getElementById('color-shadow-preview-color-link-button-hover');
window.updateLinkButtonShadowColorHover = function() {
    selectShadowHover.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectShadowHover.appendChild(option);

    colorPreviewShadowHover.style.backgroundColor = "transparent";
    colorPreviewShadowHover.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectShadowHover.appendChild(option);
    }
}
selectShadowHover.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewShadowHover.style.backgroundColor = val.settings.color;

            shadowColorHover = val.settings.color;
            var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";
            window.customStyle[".MessengerButton:hover"]["box-shadow"] = shadowHover;
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewShadowHover.style.backgroundColor = "transparent";
        colorPreviewShadowHover.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerButton:hover']['box-shadow'] = "none !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewShadowHover.style.border = "transparent";
    }
});

var shadowPosElementHover = document.getElementById("link-button-shadow-position-hover");
shadowPosElementHover.addEventListener("change", function(event) {
    if (event.target.value == "inner") {
        shadowPosHover = "inset";
    } else {
        shadowPosHover = "";
    }
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerButton:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})